export default __webpack_public_path__ + "static/media/svg5.4b8e242f.svg";